function generateRandom(len = 4) {
    const hexDigits = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
    return Array.from({ length: len }).map(() => hexDigits[0 | Math.random() * (hexDigits.length - 1)]).join('')
}

// 生成Key
export function generateId() {
    return `${new Date().getTime()}-${generateRandom()}`
}